import {useEffect} from 'react';

function useClinchEvent(eventName: string, handler: (event: CustomEvent) => void) {
  useEffect(() => {
    document.addEventListener(eventName, handler);

    return () => {
      document.removeEventListener(eventName, handler);
    };
  }, [eventName, handler]);
}

export default useClinchEvent;

export enum ClinchEvent {
  CLEInterAppRedirect = 'CLE:InterAppRedirect',
  CLEChangesUnsaved = 'CLE:changesUnsaved',
  CLENotificationStatusChanged = 'CLE:notificationStatusChanged',
  CLEClientLogoChanged = 'CLE:clientLogoChanged',
  CLStorage = 'CLE:localStorage',
}
